import request from '../utils/request.js'

export function getOrgInfo(){
    return request({
        url:'/getOrgInfo',
        method:'get'
    })
}

export function saveOrgInfo(data){
    return request({
        url:'/saveOrgInfo',
        method:'post',
        data:data
    })
}


/**
 * 测试登陆
 * @returns 
 */
 export function testLogin(){
    return request({
        url:'/testLogin',
        method:'get'
    })
}

export function getAskDetail(data){
    return request({
        url:'/getAskDetail?id='+data,
        method:'get'
    })
}


export function getAskList(data){
    return request({
        url:'/getAskList',
        method:'post',
        data:data
    })
}

export function addAsk(data){
    return request({
        url:'/addAsk',
        method:'post',
        data:data
    })
}

/**
 * 获取数据字典
 * @param {*} data 
 * @returns 
 */
export function getDictData(data){
    return request({
        url:'/getDictData?dictType='+data,
        method:'get'
    })
}
/**
 * 获取学员证件
 * @returns 
 */
export function getCustomFiles(){
    return request({
        url:'/getCustomFiles',
        method:'get'
    })
}

export function getCertificateDelegateList(){
    return request({
        url:'/getCertificateDelegateList',
        method:'get'
    })
}

export function saveCertificateDelegate(data){
    return request({
        url:'/saveCertificateDelegate',
        method:'post',
        data:data
    })
}

export function deleteCertificateDelegate(data){
    return request({
        url:'/deleteCertificateDelegate?id='+data,
        method:'get'
    })
}

/**
 * 获取学员证件
 * @returns 
 */
 export function searchCustomFiles(data){
    return request({
        url:'/searchCustomFiles',
        method:'get',
        params:data
    })
}
/**
 * 生成学员证件
 * @returns 
 */
 export function genUserfileOnline(data){
    return request({
        url:'/genUserfileOnline',
        method:'get',
        params:data
    })
}

/**
 * 绑定身份证件
 * @param {*} data 
 * @returns 
 */
export function bindIdCard(data){
    return request({
        url:'/bindIdCard',
        method:'post',
        data:data
    })
}
/**
 * 上传2寸照片
 * @param {*} data 
 * @returns 
 */
export function upPhoto(data){
    return request({
        url:'/upPhoto',
        method:'post',
        data:data
    })
}
export function getPhoto(){
    return request({
        url:'/getPhoto',
        method:'get'
    })
}
/**
 * 判断用户是否绑定过
 * @returns 
 */
export function ifBindIdCard(){
    return request({
        url:'/ifBindIdCard',
        method:'get'
    })
}
//获取用户培训列表
export function getUserTrainList(){
    return request({
        url:'/getUserTrainList',
        method:'get'
    })
}

/**
 * 前往后台进行授权登陆
 * @returns 
 */
export function login(){
    return request({
        url:'/wxLogin',
        method:'get'
    })
}
export function getSignUpList(){
    return request({
        url:'/getSignUpList',
        method:'get'
    })
}
/**
 * 返回code，服务器进行注册
 * @param {} data 
 * @returns 
 */
export function regist(data){
    return request({
        url:'/regist?code='+data,
        method:'post',
    })
}
/**
 * 用户在线填表报名
 * @param {} data 
 * @returns 
 */
export function signUp(data){
    return request({
        url:'/signUp',
        method:'post',
        data:data
    }) 
}

export function getSignUpDetail(data){
    return request({
        url:'/getSignUpDetail?id='+data,
        method:'get',
    })
}

export function deleteSignUp(data){
    return request({
        url:'/deleteSignUp?id='+data,
        method:'get',
    })
}

export function getUserInfo(){
    return request({
        url:'/getUserInfo',
        method:'get',
    })
}
